export default __webpack_public_path__ + "static/media/bg2.cdeb4613.jpg";